import React from "react";
import { useState, useEffect } from "react";
import "./Blog.css";
import Category_icon from "./Images/Group 22562.png";
import Pagination from "react-bootstrap/Pagination";
import arrowimg from "./Images/arrow-down.png";
import { Link, useParams } from "react-router-dom";
import "swiper/css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from "swiper/modules";
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { useContext } from "react";
import { Context } from "../../utils/context";
import { BlogCategoryData, InnerBlogCategoryData } from "../../utils/apis/blogs/blogsapi";
import { Breadcrumb } from "react-bootstrap";
import { faArrowLeft, faArrowRight, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination_Holder from "../common-section/Pagination_Holder/Pagination_Holder";
const Blog = () => {



  const { id } = useParams();
  // var HtmlToReactParser = require('html-to-react').Parser;
  // var htmlToReactParser = new HtmlToReactParser();
  const [currentPageData, setCurrentPageData] = useState(new Array(1).fill());
  // Example items, to simulate fetching from another resources.
  const items = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
  const { getData, mainPage, setMainPage, zoneid, setZoneid, date, setDate, IMG_URL } = useContext(Context)
  const [onPageChange, setonPageChange] = useState(1);
  const [totalPages, settotalPages] = useState();
  const [blogs, setBlogs] = useState([]);
  const [pageLinks, setPageLinks] = useState();
  const [blogCategory, setBlogCategory] = useState();
  const [category, setCategory] = useState();
  const [activeCategory, setactiveCategory] = useState();

  console.log("category", category)

  const getBlogsCategory = async () => {
    const res = await BlogCategoryData()
    if (res?.success) {
      console.log(res.data, 'BlogsCategory');
      setBlogCategory(res?.data);
      setactiveCategory(res?.data?.[0]?.id)
      getCategoryBlogs(res?.data?.[0]?.id);

      console.log("getBlogsCategory", id)

      if (id != undefined) {
        getCategoryBlogs(id);
      } else {
        getCategoryBlogs(res?.data?.[0]?.id);
      }
    }
  };




  const getCategoryBlogs = async (id, page) => {
    var res = "";

    console.log("getCategoryBlogs", id)

    // if (page) {
    //   res = await getData(`/categoryBlog?category_id=${id}&${page}`)
    // } else {
    //   res = await getData(`/categoryBlog?category_id=${id}`)
    // }

    res = await InnerBlogCategoryData(Number(id), onPageChange)

    if (res?.success) {
      console.log(res?.data, 'Blogs');
      setBlogs(res?.data?.data);
      settotalPages(res?.data?.totalPages);
      setPageLinks(res?.data?.blogs.links);

    }
  };




  useEffect(() => {

    const newId = Number(id) ? Number(id) : Number(category)

    console.log("useEffect", newId)

    getCategoryBlogs(Number(newId), onPageChange)

  }, [onPageChange])


  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  console.log("paginationItems", paginationItems)



  const ReadMore = ({ children }) => {
    const text = children;
    const [isReadMore, setIsReadMore] = useState(true);
    const toggleReadMore = () => {
      setIsReadMore(!isReadMore);
    };
    return (
      <p className="text">
        {isReadMore ? text.slice(0, 200) : text}
        <span className="mt-1 ReadMore_txt"
        >{isReadMore ? "..." : ""} </span>
      </p>
    );
  };
  useEffect(() => {
    getBlogsCategory();
  }, []);


  return (
    <>
      <section className="Blog mb-5 desktop-view-blog">
        <div className="container">

          <div className="Breadcrumb_comp">
            <Breadcrumb>
              <Breadcrumb.Item className="firstbread" href="/">
                Home <FontAwesomeIcon icon={faChevronRight} />{" "}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/studio-inner" active>
                Blogs
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>

          {blogCategory?.length > 0 ? (
            <div className="row me-0 ms-0">
              <div className="col-xl-3 col-lg-4 col-md-6  p-0">
                <div className="card-sidebar pb-5">
                  <div className="categary-class pt-3">
                    <img src={Category_icon} alt="Category_icon" className="Category_icon" /><span className="categories-txt"> Categories</span>
                    <div className="icon-txt my-2"></div>
                  </div>
                  {/* <div className="dashed-line mt-1"></div> */}

                  <div className="nav flex-column nav-pills me-3 mt-3 card-body sidebar-section" id="v-pills-tab" role="tablist" aria-orientation="vertical" >
                    {blogCategory?.map((val, index) => {
                      const isActive = id == 0 ? index == 0 : id == val?.id;

                      // const className = isActive ? "nav-link active" : "nav-link";                  

                      const newId = Number(id) ? Number(id) : Number(activeCategory)

                      console.log("newId", newId, val?.id)

                      const className = newId === val?.id ? "nav-link active" : "nav-link";

                      return (
                        <button
                          className={className}
                          id="v-pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#v-pills-home"
                          type="button"
                          role="tab"
                          aria-controls="v-pills-home"
                          aria-selected={isActive}
                          onClick={() => {
                            getCategoryBlogs(val?.id);
                            setCategory(val?.id)
                            setonPageChange(1)
                          }}
                        >
                          {val?.name}
                        </button>
                      );
                    })}



                    {/* <button className="nav-link" id="v-pills-Tarat-tab" data-bs-toggle="pill" data-bs-target="#v-pills-Tarat"
                    type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false" >
                    Tarat
                  </button> */}


                  </div>
                </div>
              </div>



              {blogs?.length > 0 ? (
                <div className="col-xl-8 col-lg-8 col-md-12 mx-auto">
                  <Swiper
                    // install Swiper modules
                    modules={[Navigation, Autoplay]}
                    spaceBetween={10}
                    slidesPerView={1}
                    navigation={false}
                    pagination={{ clickable: true }}
                    // clickable= {true}
                    onSwiper={(swiper) => console.log(swiper)}
                    onSlideChange={() => console.log('slide change')}
                  // autoplay={{
                  //   delay: 5000,
                  //   disableOnInteraction: false,
                  //   loop: true,

                  // }}                  
                  >

                    {/* <div className="row"> */}
                    <SwiperSlide>
                      <div className="tab-content" id="v-pills-tabContent">

                        <div
                          className="tab-pane fade show active"
                          id="v-pills-home"
                          role="tabpanel"
                          aria-labelledby="v-pills-home-tab"
                          tabindex="0"
                        >
                          <div className="row">

                            {blogs?.map((value, index) => (


                              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                <div className="card mb-4">
                                  <img src={IMG_URL + value?.image} className="card-section-img" alt="image"
                                  />
                                  <div className="card-upper ps-3">
                                    <p className="card-upper-heading">
                                      {value?.blog_name}
                                    </p>
                                    <p className="card-upper-info scale-in-ver-bottom" dangerouslySetInnerHTML={{ __html: value?.description }}>

                                    </p>

                                    <p>
                                      <Link to={`/readMore/${value?.id}`} className="readMore-txt">
                                        Read More &nbsp;
                                        <img src={arrowimg} className="arrow_img" alt="" />

                                      </Link>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>

                    {/* </div> */}
                  </Swiper>

                  <div className="col-md-12 mt-5 text-center">
                    <div className="pagination ">
                      {/* {pageLinks?.map((val) => (
                        <>
                          {val?.label === "&laquo; Previous" && (
                            <button tton
                              className="ms-3 previous"
                              onClick={() => {
                                getCategoryBlogs(category, val?.url.split("?")[1]);
                              }}
                            >
                              {htmlToReactParser.parse(val?.label)}
                            </button>
                          )}
    
                          {val?.label !== "&laquo; Previous" && val?.label !== "Next &raquo;" && (
                            <button
                              className={val?.active ? "ms-3 active number" : "ms-3 number"}
                              onClick={() => {
                                getCategoryBlogs(category, val?.url.split("?")[1]);
                              }}
                            >
                              {htmlToReactParser.parse(val?.label)}
                            </button>
                          )}
    
                          {val?.label === "Next &raquo;" && (
                            <button
                              className="ms-3 next"
                              onClick={() => {
                                getCategoryBlogs(category, val?.url.split("?")[1]);
                              }}
                            >
                              {htmlToReactParser.parse(val?.label)}
                            </button>
                          )}
                        </>
                      ))} */}


                      <Pagination_Holder
                        onPageChange={onPageChange}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className="col-xl-8 col-lg-8 col-md-12 mx-auto">
                  <div
                    className="text-center"
                    style={{
                      fontWeight: "bold",
                      padding: "20px",
                      color: "#000",
                    }}
                  >
                    No Data Available
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              className="text-center"
              style={{
                fontWeight: "bold",
                padding: "20px",
                color: "#000",
              }}
            >
              No Data Available
            </div>
          )}



        </div>
      </section>

      {/* mobile-view-start */}
      <section className="Blog  mobile-view-blog">
        <div className="container">

          {blogCategory?.length > 0 ? (
            <div className="row">
              <div className="d-flex ps-0 mb-2">
                <div>
                  <img src={Category_icon} className="Category_icon me-2" alt="Category_icon " />
                </div>

                <div>
                  <h3 className="mt-1 text-center categories-txt">
                    Categories
                  </h3>
                </div>
              </div>
              <Tab.Container id="left-tabs-example" >
                <Nav variant="pills" className="nav sideBoxShadowblog nav-pills">
                  <Swiper
                    modules={[Navigation]}
                    pagination={true}
                    clickable={true}
                    navigation={false}
                    breakpoints={{
                      0: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                      },
                      320: {
                        slidesPerView: 3,
                      },
                      400: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                      },
                      425: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                      },
                      567: {
                        slidesPerView: 4,
                        // spaceBetween: 10,
                      },
                      640: {
                        slidesPerView: 4,
                        // spaceBetween: 10,
                      },
                      768: {
                        slidesPerView: 5,
                        // spaceBetween: 10,
                      },

                    }}

                    className="" >
                    {blogCategory?.map((val, index) => {

                      const className = activeCategory === val?.id ? "nav-link active" : "nav-link";

                      return (
                        <SwiperSlide className='day-swiper'>
                          <Nav.Item >
                            <Nav.Link
                              eventKey={activeCategory}
                              className={`${className} mt-2`}
                              onClick={() => {
                                getCategoryBlogs(val?.id);
                                setCategory(val?.id)
                                setactiveCategory(val?.id)
                              }}
                            >
                              {val?.name}
                            </Nav.Link>
                          </Nav.Item>
                        </SwiperSlide>
                      )
                    }
                    )}

                  </Swiper>
                </Nav>


                <Tab.Content>

                  {blogs?.length > 0 ? (
                    <>
                      <div className="row mt-4">
                        {blogs?.map((value, index) => (
                          <div className=" col-sm-6 col-6">
                            <div className="card mb-4">
                              <img src={IMG_URL + value?.image} className="card-section-img" alt="image" />
                              <div className="card-upper ps-3">
                                <p className="card-upper-heading">
                                  {value?.heading}
                                </p>


                                <Link to={`/readMore/${value?.id}`} className="readMore-txt">
                                  Read More &nbsp;
                                  <img src={arrowimg} className="arrow_img" alt="" />

                                </Link>
                              </div>
                            </div>
                          </div>
                        ))}

                      </div>


                      <div className="col-md-12 mt-5 text-center">
                        <Pagination_Holder
                          onPageChange={onPageChange}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    </>
                  ) : (
                    <div
                      className="text-center"
                      style={{
                        fontWeight: "bold",
                        padding: "20px",
                        color: "#000",
                      }}
                    >
                      No Data Available
                    </div>
                  )}


                </Tab.Content>


              </Tab.Container>
            </div>
          ) : (
            <div
              className="text-center"
              style={{
                fontWeight: "bold",
                padding: "20px",
                color: "#000",
              }}
            >
              No Data Available
            </div>
          )}


        </div>
      </section>
    </>
  );
};

export default Blog;
